export default function Welcome() {
  return (
    <>
      <div className="welcome-container">
        <div
          className="welcome-bg"
          style={{ backgroundImage: "url(/loa_modal_bg.PNG)" }}
        />

        <header className="welcome-header">
          <div className="welcome-logo">LOA</div>
        </header>

        <main className="welcome-main">
          <div className="welcome-intro">
            <p className="welcome-intro-line">
              You're one of the first to see this.
            </p>
            <p className="welcome-intro-line welcome-intro-line--italic">
              We're still building. But this is what we're building towards.
            </p>
          </div>

          <section className="welcome-video-section">
            <h2 className="welcome-video-title">The Power of Reset</h2>

            <div className="welcome-video-wrapper">
              <iframe
                src="https://www.youtube.com/embed/mbIYqbgZj9E?rel=0&modestbranding=1&color=white"
                title="LOA — The Power of Reset"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              />
            </div>
          </section>

          <div className="welcome-outro">
            <p className="welcome-outro-line">
              We'll be in touch with your private access link.
            </p>
            <p className="welcome-outro-line welcome-outro-line--faded">
              In the meantime — sit with it.
            </p>
          </div>
        </main>
      </div>

      <footer className="footer">© 2026 LOA</footer>

      <style>{`
          .welcome-container {
            max-width: 760px;
            margin: 0 auto;
            padding: 100px 40px 80px;
            min-height: 100vh;
            display: flex;
            flex-direction: column;
            align-items: center;
            position: relative;
          }
  
          .welcome-bg {
            position: fixed;
            inset: 0;
            background-size: cover;
            background-position: center;
            opacity: 0.08;
            z-index: 0;
            pointer-events: none;
          }
  
          .welcome-header {
            position: fixed;
            top: 32px;
            left: 50%;
            transform: translateX(-50%);
            z-index: 100;
          }
  
          .welcome-logo {
            font-family: 'Outfit', sans-serif;
            font-size: 18px;
            font-weight: 700;
            color: var(--coral);
            letter-spacing: 4px;
          }
  
          .welcome-main {
            position: relative;
            z-index: 1;
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 64px;
          }
  
          .welcome-intro {
            text-align: center;
            display: flex;
            flex-direction: column;
            gap: 10px;
            opacity: 0;
            animation: fadeUpLine 1.2s cubic-bezier(0.4, 0, 0.2, 1) 0.3s forwards;
          }
  
          .welcome-intro-line {
            font-family: 'Crimson Pro', serif;
            font-size: 20px;
            font-weight: 300;
            line-height: 1.7;
            color: rgba(250, 248, 243, 0.85);
          }
  
          .welcome-intro-line--italic {
            font-style: italic;
            color: var(--cream);
          }
  
          .welcome-video-section {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 28px;
            opacity: 0;
            animation: fadeUpLine 1.2s cubic-bezier(0.4, 0, 0.2, 1) 0.8s forwards;
          }
  
          .welcome-video-title {
            font-family: 'Crimson Pro', serif;
            font-size: 36px;
            font-weight: 300;
            font-style: italic;
            color: var(--cream);
            letter-spacing: -0.3px;
            text-align: center;
          }
  
          .welcome-video-wrapper {
            width: 100%;
            aspect-ratio: 16 / 9;
            border-radius: 12px;
            overflow: hidden;
            box-shadow: 0 24px 60px rgba(0, 0, 0, 0.5);
            background: #111;
          }
  
          .welcome-video-wrapper iframe {
            width: 100%;
            height: 100%;
            display: block;
          }
  
          .welcome-outro {
            text-align: center;
            display: flex;
            flex-direction: column;
            gap: 8px;
            padding-bottom: 40px;
            opacity: 0;
            animation: fadeUpLine 1.2s cubic-bezier(0.4, 0, 0.2, 1) 1.3s forwards;
          }
  
          .welcome-outro-line {
            font-family: 'Outfit', sans-serif;
            font-size: 15px;
            font-weight: 300;
            color: rgba(250, 248, 243, 0.7);
            letter-spacing: 0.2px;
          }
  
          .welcome-outro-line--faded {
            font-family: 'Crimson Pro', serif;
            font-style: italic;
            font-size: 17px;
            color: rgba(250, 248, 243, 0.4);
          }
  
          @keyframes fadeUpLine {
            from { opacity: 0; transform: translateY(20px); }
            to { opacity: 1; transform: translateY(0); }
          }
  
          @media (max-width: 768px) {
            .welcome-container { padding: 80px 24px 60px; }
            .welcome-intro-line { font-size: 18px; }
            .welcome-video-title { font-size: 28px; }
            .welcome-video-wrapper { border-radius: 8px; }
          }
  
          @media (max-width: 480px) {
            .welcome-container { padding: 70px 20px 50px; }
            .welcome-intro-line { font-size: 17px; }
            .welcome-video-title { font-size: 24px; }
          }
        `}</style>
    </>
  );
}
